import _Table from "@hzero-front-ui/hzero-ui/lib/Table";
import _Input from "@hzero-front-ui/hzero-ui/lib/Input";
import _Col from "hzero-ui/lib/col";
import _Button from "@hzero-front-ui/hzero-ui/lib/Button";
import _Icon from "hzero-ui/lib/icon";
import _notification from "@hzero-front-ui/hzero-ui/lib/Notification";
import _Modal from "@hzero-front-ui/hzero-ui/lib/Modal";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _Row from "hzero-ui/lib/row";
import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";
import _Select from "@hzero-front-ui/hzero-ui/lib/Select";
import _Form from "@hzero-front-ui/hzero-ui/lib/Form";
var _templateObject;
import React, { useState } from "react";
import styled from "styled-components";
import intl from "../../../utils/intl";
import { Content, Header } from "../../../components/Page";
import { ButtonItems } from "./index.style";
import TableAction from "../../../components/TableAction"; // import operationIcon from "../../../../assets/components/svgs/operation.svg";

var Item = _Form.Item;
var Option = _Select.Option;
var StyledRow = styled(_Row)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  .ant-form-item {\n    margin-bottom: 8px;\n  }\n"])));
var TablePreview = function TablePreview(props) {
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showMore = _useState2[0],
    setShowMore = _useState2[1];
  var handleDelete = function handleDelete() {
    // 打开Modal
    _Modal.confirm({
      title: "确定删除吗？"
    });
  };
  var handlePublish = function handlePublish() {
    _Modal.confirm({
      title: "是否发布",
      onOk: function onOk() {
        return _notification.success({
          message: "发布成功",
          duration: 3
        });
      },
      onCancel: function onCancel() {
        return _notification.info({
          message: "取消发布",
          duration: 3
        });
      }
    });
  };
  var tableActionOptions = [{
    key: "1",
    text: "编辑",
    icon: "edit",
    action: function action() {
      return props.onNext();
    }
  }, {
    key: "2",
    text: "发布",
    icon: "cloud-upload",
    action: handlePublish
  }, {
    key: "3",
    text: "删除",
    icon: "delete",
    subOptions: [{
      key: "3-1",
      text: "删除远端",
      icon: "delete",
      action: handleDelete
    }, {
      key: "3-2",
      text: "删除本地",
      icon: "delete",
      action: handleDelete
    }]
  }];
  var tableProps = {
    dataSource: Array.from({
      length: 500
    }).map(function (v, i) {
      return {
        type: "\u7CFB\u7EDF\u516C\u544A".concat(i),
        title: "\u8FD9\u662F\u6807\u9898\u6587\u6848\u8FD9\u662F\u6807\u9898\u6587\u6848\u8FD9\u662F\u6807\u9898\u6587\u6848\u8FD9\u662F\u6807\u9898\u6587\u6848\u8FD9\u662F\u6807\u9898\u6587\u6848\u8FD9\u662F\u6807\u9898\u6587\u6848".concat(i),
        publisher: "\u7BA1\u7406\u5458".concat(i),
        status: "\u5DF2\u53D1\u5E03".concat(i),
        publishTime: "2019-8-15".concat(i),
        action: "...".concat(i)
      };
    }),
    columns: [{
      title: intl.get("hzero.hzeroTheme.page.annoType").d("公告类型"),
      dataIndex: "type",
      key: "type"
    }, {
      title: intl.get("hzero.hzeroTheme.page.annoTitle").d("公告标题"),
      dataIndex: "title",
      key: "title"
    }, {
      title: intl.get("hzero.hzeroTheme.page.publisher").d("发布人"),
      dataIndex: "publisher",
      key: "publisher"
    }, {
      title: intl.get("hzero.hzeroTheme.page.annoStatus").d("公告状态"),
      dataIndex: "status",
      key: "status"
    }, {
      title: intl.get("hzero.hzeroTheme.page.publishTime").d("发布时间"),
      dataIndex: "publishTime",
      key: "publishTime"
    }, {
      title: "操作",
      dataIndex: "action",
      render: function render() {
        return /*#__PURE__*/React.createElement(TableAction, {
          options: tableActionOptions
        });
      },
      key: "action"
    }],
    pagination: {
      pageSize: 10,
      totalCount: 500
    },
    rowKey: function rowKey(record) {
      return record.type;
    }
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Header, {
    title: intl.get("hzero.hzeroTheme.page.tablePreview").d("表格预览"),
    onBack: props.onBack,
    hideBackBtn: true
  }, /*#__PURE__*/React.createElement(_Button, {
    onClick: props.onExit,
    type: "primary"
  }, /*#__PURE__*/React.createElement(_Icon, {
    type: "logout"
  }), intl.get("hzero.hzeroTheme.page.exitPreview").d("退出预览"))), /*#__PURE__*/React.createElement(Content, null, /*#__PURE__*/React.createElement(StyledRow, {
    type: "flex",
    gutter: 24,
    align: "bottom"
  }, /*#__PURE__*/React.createElement(_Col, {
    span: 5
  }, /*#__PURE__*/React.createElement(Item, {
    label: intl.get("hzero.hzeroTheme.page.annoTitle").d("公告标题")
  }, /*#__PURE__*/React.createElement(_Select, {
    defaultValue: "1"
  }, /*#__PURE__*/React.createElement(Option, {
    value: "1"
  }, "\u9009\u98791"), /*#__PURE__*/React.createElement(Option, {
    value: "2"
  }, "\u9009\u98792"), /*#__PURE__*/React.createElement(Option, {
    value: "3"
  }, "\u9009\u98793"), /*#__PURE__*/React.createElement(Option, {
    value: "4"
  }, "\u9009\u98794")))), /*#__PURE__*/React.createElement(_Col, {
    span: 5
  }, /*#__PURE__*/React.createElement(Item, {
    label: intl.get("hzero.hzeroTheme.page.companyName").d("公司名称")
  }, props.form.getFieldDecorator("name")( /*#__PURE__*/React.createElement(_Input, null)))), /*#__PURE__*/React.createElement(_Col, {
    span: 5
  }, /*#__PURE__*/React.createElement(Item, {
    label: intl.get("hzero.hzeroTheme.page.deptName").d("部门名称")
  }, props.form.getFieldDecorator("dept")( /*#__PURE__*/React.createElement(_Input, null)))), /*#__PURE__*/React.createElement(_Col, {
    span: 7
  }, /*#__PURE__*/React.createElement(ButtonItems, null, /*#__PURE__*/React.createElement(_Button, {
    onClick: function onClick() {
      return setShowMore(function (v) {
        return !v;
      });
    }
  }, intl.get("hzero.hzeroTheme.page.more").d("更多")), /*#__PURE__*/React.createElement(_Button, null, intl.get("hzero.hzeroTheme.page.reset").d("重置")), /*#__PURE__*/React.createElement(_Button, {
    type: "primary"
  }, intl.get("hzero.hzeroTheme.page.query").d("查询"))))), showMore && /*#__PURE__*/React.createElement(_Row, {
    type: "flex",
    gutter: 24,
    align: "bottom"
  }, /*#__PURE__*/React.createElement(_Col, {
    span: 5
  }, /*#__PURE__*/React.createElement(Item, {
    label: "".concat(intl.get("hzero.hzeroTheme.page.query").d("查询"), " 1")
  }, /*#__PURE__*/React.createElement(_Input, null))), /*#__PURE__*/React.createElement(_Col, {
    span: 5
  }, /*#__PURE__*/React.createElement(Item, {
    label: "".concat(intl.get("hzero.hzeroTheme.page.query").d("查询"), " 2")
  }, /*#__PURE__*/React.createElement(_Input, null)))), /*#__PURE__*/React.createElement(_Table, tableProps)));
};
TablePreview.defaultProps = {
  onBack: function onBack() {},
  onNext: function onNext() {},
  onExit: function onExit() {}
};
export default _Form.create()(TablePreview);